/* Joelheira — funil. Reescrito para a loja nova. */
(function () {
  'use strict';

  var D = window.JF || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    return (cents / 100).toLocaleString('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var routes = window.routes || {};

  /* ---------------- Galeria ---------------- */
  var media = D.media || [];
  var gi = 0;
  var galMain = $('#galMain');
  var galThumbs = $('#galThumbs');

  function showImg(i) {
    if (!media.length || !galMain) return;
    gi = (i + media.length) % media.length;
    galMain.src = media[gi].big;
    $$('.gal__th', galThumbs).forEach(function (t, k) {
      t.classList.toggle('is-on', k === gi);
      t.setAttribute('aria-current', k === gi ? 'true' : 'false');
    });
  }

  if (galThumbs && media.length > 1) {
    media.forEach(function (m, k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gal__th' + (k === 0 ? ' is-on' : '');
      b.setAttribute('aria-label', 'Ver foto ' + (k + 1));
      b.innerHTML = '<img src="' + esc(m.th) + '" alt="" loading="lazy" width="68" height="68">';
      b.addEventListener('click', function () { showImg(k); });
      galThumbs.appendChild(b);
    });
    $('#galPrev').addEventListener('click', function () { showImg(gi - 1); });
    $('#galNext').addEventListener('click', function () { showImg(gi + 1); });

    // Deslizar com o dedo na foto principal
    var x0 = null;
    galMain.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    galMain.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) showImg(gi + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  } else {
    ['#galPrev', '#galNext'].forEach(function (s) { var el = $(s); if (el) el.hidden = true; });
  }

  /* ---------------- Variantes ---------------- */
  var sel = (D.init || []).slice();
  var variants = D.variants || [];

  function findVariant(a, b) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.o1 === a && (v.o2 === b || v.o2 == null)) return v;
    }
    return null;
  }
  function current() { return findVariant(sel[0], sel[1]); }

  $$('.pill').forEach(function (b) {
    b.addEventListener('click', function () {
      sel[+b.dataset.opt] = b.dataset.val;
      update();
    });
  });

  /* ---------------- Pacotes ---------------- */
  // Cada pacote pode ter varias unidades, cada uma com o seu tamanho e lado.
  var deals = $$('.deal');
  var opts = D.opts || [];
  var qty = 1;
  var units = {};
  var startDeal = deals.filter(function (d) { return d.hasAttribute('data-default'); })[0] || deals[0];
  if (startDeal) qty = +startDeal.dataset.qty || 1;

  function activeDeal() {
    for (var i = 0; i < deals.length; i++) if ((+deals[i].dataset.qty || 1) === qty) return deals[i];
    return null;
  }

  function unitsFor(n) {
    if (!units[n]) {
      units[n] = [];
      for (var i = 0; i < n; i++) units[n].push(sel.slice());
    }
    return units[n];
  }

  function buildUnits(d) {
    var box = $('.deal__units', d);
    var n = +d.dataset.qty || 1;
    var free = +d.dataset.free || 0;
    if (n < 2 || !opts.length) { box.hidden = true; return; }
    var u = unitsFor(n);
    if (box.dataset.built !== '1') {
      box.innerHTML = u.map(function (val, i) {
        var lb = 'Un. ' + (i + 1) + (i >= n - free ? ' grátis' : '');
        return '<div class="unit"><span class="unit__lb">' + lb + '</span>' +
          opts.map(function (o, k) {
            var id = 'u' + n + '_' + i + '_' + k;
            return '<label class="visually-hidden" for="' + id + '">' + esc(o.name) + ', ' + lb + '</label>' +
              '<select id="' + id + '" data-u="' + i + '" data-k="' + k + '">' +
              o.values.map(function (v) {
                return '<option value="' + esc(v) + '"' + (v === val[k] ? ' selected' : '') + '>' + esc(v) + '</option>';
              }).join('') + '</select>';
          }).join('') + '</div>';
      }).join('');
      box.dataset.built = '1';
      box.addEventListener('change', function (e) {
        var t = e.target;
        if (t.tagName !== 'SELECT') return;
        u[+t.dataset.u][+t.dataset.k] = t.value;
        update();
      });
    }
    box.hidden = false;
  }

  deals.forEach(function (d) {
    $('.deal__pick', d).addEventListener('click', function () {
      qty = +d.dataset.qty || 1;
      update();
    });
  });

  // Linhas a enviar para o carrinho, ou null se alguma unidade estiver esgotada
  function cartItems() {
    if (qty < 2 || !activeDeal()) {
      var v = current();
      return v && v.ok ? [{ id: v.id, quantity: Math.max(qty, 1) }] : null;
    }
    var u = unitsFor(qty), count = {}, order = [];
    for (var i = 0; i < u.length; i++) {
      var vv = findVariant(u[i][0], u[i][1]);
      if (!vv || !vv.ok) return null;
      if (!count[vv.id]) { count[vv.id] = 0; order.push(vv.id); }
      count[vv.id]++;
    }
    return order.map(function (id) { return { id: id, quantity: count[id] }; });
  }

  var pNow = $('#pNow'), pWas = $('#pWas');
  var stickNow = $('#stickNow'), stickWas = $('#stickWas'), stickName = $('#stickName');
  var atcMain = $('#atcMain'), atcLabel = $('#atcLabel'), atcStick = $('#atcStick');
  var atcErr = $('#atcErr');

  function update() {
    $$('.pill').forEach(function (b) {
      var i = +b.dataset.opt;
      var on = sel[i] === b.dataset.val;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var test = i === 0 ? findVariant(b.dataset.val, sel[1]) : findVariant(sel[0], b.dataset.val);
      b.classList.toggle('is-off', !test || !test.ok);
    });
    var lbSize = $('#lbSize'), lbSide = $('#lbSide');
    if (lbSize && sel[0] != null) lbSize.textContent = sel[0];
    if (lbSide && sel[1] != null) lbSide.textContent = sel[1];

    var dealOn = activeDeal();
    deals.forEach(function (d) {
      var on = d === dealOn;
      d.classList.toggle('is-on', on);
      $('.deal__pick', d).setAttribute('aria-checked', on ? 'true' : 'false');
      if (on) buildUnits(d); else $('.deal__units', d).hidden = true;
    });
    var multi = !!(dealOn && qty > 1 && opts.length);
    $$('.field--opt').forEach(function (f) { f.hidden = multi; });

    var v = current();
    var nowTxt, wasTxt = '';
    if (dealOn && dealOn.dataset.price) {
      nowTxt = dealOn.dataset.price;
      wasTxt = dealOn.dataset.was || '';
    } else if (v) {
      nowTxt = money(v.price * qty);
      wasTxt = v.was > v.price ? money(v.was * qty) : '';
    }
    if (nowTxt != null) {
      pNow.textContent = nowTxt;
      pWas.textContent = wasTxt;
      pWas.hidden = !wasTxt;
      if (stickNow) stickNow.textContent = nowTxt;
      if (stickWas) stickWas.textContent = wasTxt;
    }
    if (stickName) stickName.textContent = multi ? dealOn.dataset.label : (D.productName || '');

    if (!multi && v && v.img && media.length) {
      for (var k = 0; k < media.length; k++) {
        if (media[k].big.split('?')[0] === v.img.split('?')[0]) { showImg(k); break; }
      }
    }

    var ok = !!cartItems();
    atcMain.disabled = !ok;
    if (atcStick) atcStick.disabled = !ok;
    atcLabel.textContent = ok ? 'Adicionar ao carrinho' : (multi ? 'Há uma unidade esgotada' : (v ? 'Esgotado' : 'Indisponível'));
    if (atcErr) atcErr.hidden = true;
  }
  update();

  /* ---------------- Adicionar ao carrinho ---------------- */
  function addToCart(btn) {
    var items = cartItems();
    if (!items) return;
    btn.classList.add('is-loading');
    if (atcErr) atcErr.hidden = true;
    fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        });
      })
      .then(function () { cart.abrir(); })
      .catch(function (e) {
        if (atcErr) {
          atcErr.textContent = (e && (e.description || e.message)) || 'Não foi possível adicionar ao carrinho. Tenta outra vez.';
          atcErr.hidden = false;
        }
      })
      .then(function () { btn.classList.remove('is-loading'); });
  }
  atcMain.addEventListener('click', function () { addToCart(atcMain); });
  if (atcStick) atcStick.addEventListener('click', function () { addToCart(atcStick); });

  /* ---------------- Barra fixa ---------------- */
  var stick = $('#stick');
  if (stick && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      stick.classList.toggle('is-on', show);
      stick.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (atcStick) atcStick.tabIndex = show ? 0 : -1;
    }).observe(atcMain);
  }

  /* ---------------- Acordeoes ---------------- */
  $$('.acc__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var acc = q.closest('.acc');
      var open = acc.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------------- Carrinho lateral ---------------- */
  var cd = $('#cd');
  var lastFocus = null;

  var cart = {
    carregar: function () {
      return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render);
    },
    mudar: function (line, quantity) {
      cd.setAttribute('aria-busy', 'true');
      return fetch((routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .then(function () { cd.removeAttribute('aria-busy'); });
    },
    abrir: function () {
      if (!cd) { window.location.href = routes.cart_url || '/cart'; return; }
      lastFocus = document.activeElement;
      cd.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        cd.classList.add('is-open');
        $('.cd__panel', cd).focus();
      });
      cart.carregar();
    },
    fechar: function () {
      if (!cd) return;
      cd.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { cd.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  };

  function render(c) {
    var n = c.item_count || 0;
    var head = $('#jfCartN');
    if (head) { head.textContent = n; head.hidden = n === 0; }
    $('#cdCount').textContent = '• ' + n;

    var ul = $('#cdItems');
    ul.innerHTML = (c.items || []).map(function (it, i) {
      var line = i + 1;
      var img = it.image || '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<li class="cd__it">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72">' : '<span></span>') +
        '<div>' +
          '<p class="cd__it-t">' + esc(it.product_title) + '</p>' +
          (it.variant_title ? '<p class="cd__it-v">' + esc(it.variant_title) + '</p>' : '') +
          '<div class="cd__qty">' +
            '<button type="button" data-line="' + line + '" data-q="' + (it.quantity - 1) + '" aria-label="Menos uma">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-line="' + line + '" data-q="' + (it.quantity + 1) + '" aria-label="Mais uma">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cd__it-p"><b>' + money(it.final_line_price) + '</b>' + was +
          '<button type="button" class="cd__rm" data-line="' + line + '" data-q="0">Remover</button>' +
        '</div>' +
      '</li>';
    }).join('');

    $('#cdEmpty').hidden = n > 0;
    $('#cdGo').disabled = n === 0;

    var tot = '';
    if (c.total_discount > 0) {
      tot += '<div class="cd__tot-l poup"><span>Poupas</span><span>' + money(c.total_discount) + '</span></div>';
    }
    tot += '<div class="cd__tot-l big"><span>Total</span><span>' + money(c.total_price) + '</span></div>';
    $('#cdTot').innerHTML = n ? tot : '';

    var limit = D.freeShip || 0;
    var bar = $('#cdBar'), shipT = $('#cdShipT');
    if (limit <= 0 || c.total_price >= limit) {
      bar.style.width = '100%';
      shipT.innerHTML = 'Envio <b>grátis</b> desbloqueado!';
    } else {
      bar.style.width = Math.round((c.total_price / limit) * 100) + '%';
      shipT.innerHTML = 'Faltam <b>' + money(limit - c.total_price) + '</b> para o envio grátis';
    }
    return c;
  }

  if (cd) {
    $('#cdItems').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-line]');
      if (b) cart.mudar(+b.dataset.line, Math.max(0, +b.dataset.q));
    });
    $('#cdX').addEventListener('click', cart.fechar);
    $('#cdOv').addEventListener('click', cart.fechar);
    $('#cdGo').addEventListener('click', function () { window.location.href = D.checkout || '/checkout'; });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !cd.hidden) cart.fechar();
    });
  }

  window.JF_carrinho = cart;

  /* ---------------- Avaliacoes ---------------- */
  var more = $('#rwMore');
  if (more) {
    more.addEventListener('click', function () {
      $$('.rv.is-extra').forEach(function (r) { r.hidden = false; });
      more.hidden = true;
    });
  }

  var abrir = $('#rwAbrir'), corpo = $('#rwCorpo'), form = $('#rwForm');
  if (abrir && corpo && form) {
    var nota = 0;
    var notas = $$('.rwf__nota');
    var pintar = function (n) {
      notas.forEach(function (b) {
        var on = +b.dataset.n <= n;
        b.classList.toggle('on', on);
        b.setAttribute('aria-checked', +b.dataset.n === nota ? 'true' : 'false');
      });
    };
    notas.forEach(function (b) {
      b.addEventListener('click', function () { nota = +b.dataset.n; $('#rwNotaVal').value = nota + ' estrelas'; pintar(nota); });
      b.addEventListener('mouseenter', function () { pintar(+b.dataset.n); });
      b.addEventListener('mouseleave', function () { pintar(nota); });
    });

    abrir.addEventListener('click', function () {
      abrir.hidden = true;
      corpo.hidden = false;
      $('#rwNome').focus();
    });
    $('#rwCancelar').addEventListener('click', function () {
      corpo.hidden = true;
      abrir.hidden = false;
      abrir.focus();
    });

    form.addEventListener('submit', function (e) {
      var erro = $('#rwErro');
      var falta = [];
      if (!nota) falta.push('a nota');
      if (!$('#rwNome').value.trim()) falta.push('o nome');
      if (!$('#rwEmail').value.trim()) falta.push('o email');
      if ($('#rwTexto').value.trim().length < 10) falta.push('o texto (pelo menos 10 caracteres)');
      if (falta.length) {
        e.preventDefault();
        erro.textContent = 'Falta preencher ' + falta.join(', ') + '.';
        erro.hidden = false;
      }
    });
  }
})();
